import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Logo = (props: SvgIconProps) => {
    return (
        <SvgIcon width="61" height="34" viewBox="0 0 61 34" fill="none" {...props}>
            <path fill="#fff" d="M33.6 17A16.6 16.6 0 1 1 .4 17a16.6 16.6 0 0 1 33.2 0Z" />
            <path fill="url(#a)" d="M15.56 13.49a1 1 0 0 1 .76.42l5.26 7.95 2.12-10.4H11.46v2.03h4.1Z" />
            <path
                fill="url(#b)"
                d="M30.73 8.78c1.19 3.31.71 7.06-1.32 9.51a10.1 10.1 0 0 1-3.49 2.62l-.87 4.3a.65.65 0 0 1-.6.5h-4.3a1 1 0 0 1-.77-.42l-5.25-7.94-.39 1.88-1.22 5.99a.65.65 0 0 1-.6.48h-.51c0 3.64 4.84 7.76 12.88 5.52a16.01 16.01 0 0 0 6.43-22.45l.01.01Z"
            />
            <path
                fill="url(#c)"
                d="M1.63 19.37c0-5.97 4.1-7.92 8.42-7.92h1.45v2.04h-.24a.64.64 0 0 0-.6.49l-.12.59-2.17 10.65a.39.39 0 0 0 .4.48h2.65c0 3.64 4.84 7.76 12.89 5.52A16 16 0 0 1 17 32.98c-9.19 0-15.37-7.55-15.37-13.61Z"
            />
            <path
                fill="url(#d)"
                d="M25.92 20.91c1.35-.6 2.56-1.5 3.53-2.62 2.01-2.48 2.5-6.2 1.32-9.5a16.03 16.03 0 0 0-11-7.56C16.61 1 13.61 1.85 12 3.92c-.7.96-.84 2.27-.5 3.77h12.46a1 1 0 0 1 .76.42l2.61 4.11c.16.28.22.6.17.91l-1.58 7.78Z"
            />
            <path
                fill="url(#e)"
                d="M19.76 1.23C16.62 1 13.62 1.85 12 3.92c-.7.95-.84 2.27-.5 3.77H4.8c-.71 0-.64-.3-.07-.98a15.97 15.97 0 0 1 15.03-5.48Z"
            />
            <path
                fill="url(#f)"
                d="m8.38 25.22 2.16-10.65h-1.6a.66.66 0 0 0-.6.5L6.22 25.22a.4.4 0 0 0 .4.5h2.12a.39.39 0 0 1-.36-.5Z"
                style={{ mixBlendMode: "multiply" }}
            />
            <path
                fill="url(#g)"
                d="M18.48 25.7h1.67a1.01 1.01 0 0 1-.77-.41l-5.25-7.94-.39 1.88 3.86 5.99a1.18 1.18 0 0 0 .88.48Z"
                style={{ mixBlendMode: "multiply" }}
            />
            <path
                fill="url(#h)"
                d="M1.63 19.37c0-5.97 4.1-7.92 8.42-7.92h13.62l-2.12 10.4-5.23-7.92a1 1 0 0 0-.76-.42h-4.3a.64.64 0 0 0-.6.49l-.12.59-2.17 10.63a.39.39 0 0 0 .4.48h3.16a.65.65 0 0 0 .59-.48l1.21-6 .38-1.89 5.27 7.96a1 1 0 0 0 .77.41h4.3a.65.65 0 0 0 .6-.48l.87-4.3 1.59-7.77c.05-.32-.01-.65-.18-.93l-2.63-4.1a1 1 0 0 0-.76-.42H4.79c-.7 0-.63-.3-.06-.98a15.97 15.97 0 0 1 15.03-5.48A16 16 0 0 1 17 33c-9.2-.02-15.37-7.57-15.37-13.63Z"
                style={{ mixBlendMode: "multiply" }}
            />
            <path
                fill="#000"
                d="M46.76 11.96v6.16l-3.9-5.46a1.75 1.75 0 0 0-1.31-.7h-2.48l-.15.81.5.1c.26.07.38.33.38.95v7.64h2.12v-6.22l4.05 5.64a1.59 1.59 0 0 0 1.17.6h1.74v-9.52h-2.12Zm11.53 0v6.16l-3.93-5.46a1.75 1.75 0 0 0-1.3-.7h-2.44l-.15.81.5.1c.25.07.37.33.37.95v7.64h2.12v-6.22l4.05 5.64a1.57 1.57 0 0 0 1.18.6h1.73v-9.52h-2.13Z"
            />
            <defs>
                <linearGradient id="a" x1="24.51" x2="13.07" y1="13.75" y2="17.91" gradientUnits="userSpaceOnUse">
                    <stop offset=".34" stopColor="#F7AC00" />
                    <stop offset=".85" stopColor="#F08800" />
                </linearGradient>
                <linearGradient id="b" x1="22.21" x2="22.21" y1="31.87" y2="8.78" gradientUnits="userSpaceOnUse">
                    <stop offset=".01" stopColor="#EE7D00" />
                    <stop offset=".25" stopColor="#F29200" />
                    <stop offset=".78" stopColor="#F29200" />
                    <stop offset=".99" stopColor="#F49D00" />
                </linearGradient>
                <linearGradient id="c" x1="6.2" x2="17.93" y1="28.96" y2="19.12" gradientUnits="userSpaceOnUse">
                    <stop offset=".21" stopColor="#E9600F" />
                    <stop offset=".54" stopColor="#EB6B0A" />
                    <stop offset=".82" stopColor="#F08800" />
                </linearGradient>
                <linearGradient id="d" x1="17.97" x2="26.37" y1="14.58" y2="4.01" gradientUnits="userSpaceOnUse">
                    <stop offset=".52" stopColor="#F7AB00" />
                    <stop offset=".86" stopColor="#FECA00" />
                </linearGradient>
                <linearGradient id="e" x1="597.07" x2="597.07" y1="216.68" y2="153" gradientUnits="userSpaceOnUse">
                    <stop offset=".01" stopColor="#EE7D00" />
                    <stop offset=".25" stopColor="#F29200" />
                    <stop offset=".78" stopColor="#F29200" />
                    <stop offset=".99" stopColor="#F49D00" />
                </linearGradient>
                <linearGradient id="f" x1="8.38" x2="8.38" y1="25.72" y2="14.57" gradientUnits="userSpaceOnUse">
                    <stop offset=".31" stopColor="#fff" />
                    <stop offset=".63" stopColor="#F2A8C7" />
                </linearGradient>
                <linearGradient id="g" x1="16.95" x2="16.95" y1="25.7" y2="17.35" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#fff" />
                    <stop offset=".29" stopColor="#F7C7DC" />
                </linearGradient>
                <radialGradient
                    id="h"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="translate(18.23 15.84) scale(16.7214)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".83" stopColor="#fff" />
                    <stop offset=".95" stopColor="#F7CADD" />
                </radialGradient>
            </defs>
        </SvgIcon>
    );
};
